import { DatePicker, Form, Input, Modal, Radio, Select, message } from "antd";
import { UploadFile } from "antd/lib/upload/interface";
import React, { useContext, useEffect, useState } from "react";
import { BUTTON_PROPS } from "../../constants/general";
import AppContext from "../../context/app.context";
import { IAppContext } from "../../interfaces/context.interfaces";
import { IProject, IServerEvent, IUser } from "../../interfaces/map.interfaces";
import MapDataContext from "../MapData/map.data.context";
import { IDeckGlInfoObject } from "./deck.gl.map";
import UploadGeoJSON from "./uploadGeoJson";
import { GeoJsonObject } from "geojson";

function AddCrownClosureEvent({
  event,
  enabled,
  setEnableHeli,
  refreshEvents,
}: {
  event: IDeckGlInfoObject;
  enabled: boolean;
  setEnableHeli : Function
  refreshEvents: Function;
}) {
  const appContext: IAppContext = useContext(AppContext);
  const mapDataContext = useContext(MapDataContext);

  const [user, setUser] = useState<IUser>();
  const [project, setProject] = useState<IProject>();
  const [visible, setVisible] = useState<boolean>(enabled);
  const [initialClick, setInitialClick] = useState(true);
  const [count, setCount] = useState(0);
  const [geojsonFile, setGeojsonFile] = useState<GeoJsonObject | null>(null);
  const [newEventState, setNewEventState] = useState<string>();
  const [newTypeState, setNewTypeState] = useState<string>();
  const [detectedBy, setDetectedBy] = useState<string>();
  const [newSubTypeState, setNewSubTypeState] = useState<string>();
  const [newEventDate, setNewEventDate] = useState<any>(null);
  const [newEventComment, setNewEventComment] = useState<string>("");
  const [newEventAuthor, setNewEventAuthor] = useState<string>();
  const [confirmLoading, setConfirmLoading] = useState<boolean>(false);
  const [imageFile, setImageFile] = useState<UploadFile>(null);

  const language = user?.language;

  useEffect(() => {
    appContext.services.userService.getMyData().then((data) => {
      setUser(data.data);
      setNewEventAuthor(data.data?.email || "");
    });
    appContext.services.projectService.getMyData().then((data) => {
      setProject(data.data[0]);
    });
  }, []);

  useEffect(() => {
    if (!enabled) {
      setInitialClick(true);
      setCount(0);
    }
  }, [enabled]);

  useEffect(() => {
    if (!event) return;
    setVisible(true);
    enabled && setCount(count + 1);
  }, [event]);

  useEffect(() => {
    if (count > 1) {
      setInitialClick(false);
    }
  }, [count]);

  useEffect(() => {
    if (!visible) return;
    setNewSubTypeState("");
    setNewTypeState("");
    setNewEventState("");
  }, [event, visible]);

  if (event.object) return null;

  const onAddEvent = async (event: IServerEvent) => {
    // if (!appContext) {
    //   return;
    // }
    // if (embeddedApp) {
    //   appContext.services.sviEventService.addHeliEvent(event).then((data) => {
    //   appContext.services.imageService.uploadImage(
    //     imageFile?.originFileObj as File,
    //     data?.data?.properties?.id + ".png"
    //   );
    // });
    // } else {
    //   appContext.services.eventService.addHeliEvent(event).then((data) => {
    //   appContext.services.imageService.uploadImage(
    //     imageFile?.originFileObj as File,
    //     data?.data?.properties?.id + ".png"
    //   );
    // });
    // }

     if (!mapDataContext) {
      return;
    }

    try {
      const data = await appContext.services.crownClosureService.addHeliEvent(event);
      appContext.services.imageService.uploadImage(
        imageFile?.originFileObj as File,
        data?.data?.properties?.id + ".png"
      );

      setTimeout(() => {
        refreshEvents();
      }, 1000);
      message.success(
        language === "de"
          ? "Ereignis erfolgreich erstellt."
          : "Event created successfully."
      );
    } catch (error) {
      message.error(
        language === "de"
          ? "Ereignis konnte nicht erstellt werden."
          : "Failed to create event."
      );
    }
  };

  const handleOk = (event: IDeckGlInfoObject) => {
    setConfirmLoading(true);
    setTimeout(() => {
      const newEvent: IServerEvent = {
        properties: {
          id: "",
          locationId: "",
          type: "Kronenschlüsse" ,
          sourcetype: "heli",
          subType: newSubTypeState,
          comment: newEventComment,
          state: newEventState,
          date: newEventDate ? newEventDate.format("YYYY-MM-DD") : "",
          author: newEventAuthor,
          projectId: project?.id,
          image: imageFile ? "_" : "",
          detectedBy: detectedBy,
          geojson:geojsonFile ?? undefined
        },
        geometry: {
          type: "Point",
          coordinates: event.coordinate,
        },
      };

      onAddEvent(newEvent);

      setVisible(false);
      setConfirmLoading(false);
    }, 2000);
    setNewSubTypeState("");
    setNewTypeState("");
    setDetectedBy("")
    setNewEventState("");
    setNewEventComment("");
    setNewEventDate(null);
    setImageFile(null);
    setEnableHeli(false);
    setGeojsonFile(null);
  };

  const handleCancel = () => {
    setNewSubTypeState("");
    setNewTypeState("");
    setDetectedBy("")
    setNewEventState("");
    setNewEventComment("");
    setNewEventDate(null);
    setVisible(false);
    setImageFile(null);
    setEnableHeli(false)
  };

  return (
    <Modal
      title={language === "de" ? "Bearbeiten" : "Edit"}
      className="MapDeckComment"
      centered
      okText={"Submit"}
      visible={visible && enabled && !initialClick}
      onOk={() => {
        handleOk(event);
      }}
      confirmLoading={confirmLoading}
      onCancel={handleCancel}
      okButtonProps={{
        type: "primary",
        shape: "round",
        size: "small",
        disabled:
          !newEventState &&
          !newSubTypeState &&
          !newTypeState &&
          !newEventComment,
      }}
      cancelButtonProps={{
        ...BUTTON_PROPS,
        type: "danger",
        shape: "round",
        size: "small",
      }}
    >
      <Form onClick={(e) => e.stopPropagation()}>
        <Form.Item label={language === "de" ? "Status" : "State"}>
          <Radio.Group
            defaultValue={newEventState}
            onChange={(e) => setNewEventState(e.target.value)}
            value={newEventState}
          >
            <Radio.Button value={"checked"}>
              {language === "de" ? "Checked" : "Checked"}
            </Radio.Button>
            <Radio.Button value={"unchecked"}>
              {language === "de" ? "Un-checked" : "Un-checked"}
            </Radio.Button>
          </Radio.Group>
        </Form.Item>
        <Form.Item label={language === "de" ? "Typ" : "Type"}>
            <Select
                style={{ width: 200 }}
                value="Kronenschlüsse"
                disabled
            >
                <Select.Option value="Kronenschlüsse">Kronenschlüsse</Select.Option>
            </Select>
        </Form.Item>
        <Form.Item label={language === "de" ? "Datum" : "Date"}>
          <DatePicker
            style={{ width: "100%" }}
            value={newEventDate}
            onChange={(date) => setNewEventDate(date)}
            format="YYYY-MM-DD"
          />
        </Form.Item>
        <Form.Item label={language === "de" ? "Kommentar" : "Comment"}>
          <Input
            placeholder={
              language === "de"
                ? "Schreiben Sie Ihren Kommentar..."
                : "Write your comment..."
            }
            value={newEventComment}
            onChange={(e) => setNewEventComment(e.target.value)}
          />
        </Form.Item>
        <Form.Item label={language === "de" ? "Bearbeiter" : "Editor"}>
          <Input
            placeholder={language === "de" ? "Name des Autors" : "Author Name"}
            value={newEventAuthor}
            onChange={(e) => setNewEventAuthor(e.target.value)}
          />
        </Form.Item>
        <Form.Item label="GeoJSON File">
        <UploadGeoJSON file={geojsonFile} setFile={setGeojsonFile} />
      </Form.Item>
      </Form>
      
    </Modal>
  );
}

export default AddCrownClosureEvent;
